import { AccountPermissions } from "./account-permissions";

export {
	AccountPermissions
}